export default function Grid() {
  return {
    MuiGrid: {
      styleOverrides: {
        root: {
          // MuiGrid-root
          '&.MuiGrid-container': {
            flexGrow: 1 // Make Grid container take all available space in Page/Container components
          },
          '.MuiGrid-item': {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch'
          }
        }
      }
    }
  };
}
